module.exports = __webpack_public_path__ + "img/on-demand-dark.39b071dc.svg";